import { formatNumberPrice } from '~/shared/lib/helpers';
import classes from './Recommendations.module.scss';

interface IProps {
    image: any;
    content: string;
    price: number;
}

const RecommendationItem = ({ content, image, price }: IProps) => (
    <li className={ classes.item }>
        <div className={classes.image_container}>
            <img src={ image } alt={'recommendation'} />
        </div>
        <span className={ classes.content }>{ decodeURIComponent(content) }</span>
        <span className={ classes.price }>{ formatNumberPrice(price) }</span>
    </li>
);

export default RecommendationItem;
